


import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";



const storeApi = (set) => ({
    iva: false,
    observacionCotizacion: '',
    view: null,
    pageCliente: '/',

    cambiarIva: (valor) => {
        set({ iva: valor });
    },

    cambioRolVenta: (valor) => {
        set({ view: valor });
    },


    cambiarObservacion: (valor) => {
        set({ observacionCotizacion: valor });
    },


    cambiarPageCliente: (valor) => {
        set({ pageCliente: valor });
    },
    

});




export const useGlobalValueStore = create(
    // devtools(storeApi)
    devtools(
        persist(storeApi, {
            name: 'global-values',   
            partialize: (state) => ({
                view: state.view,                
                iva: state.iva, 
                pageCliente: state.pageCliente,
            })
        })
    )
);
